import React, { useCallback } from 'react'

const useHandleChangeTextArea = (
  setText: React.Dispatch<React.SetStateAction<string>>,
  MAX_CHARS: number
) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
      const { value } = event.target

      if (value?.length > MAX_CHARS) {
        return
      }

      setText(value)
    },
    [setText, MAX_CHARS]
  )

  return handleChange
}

export default useHandleChangeTextArea
